// extracted by mini-css-extract-plugin
export default {"overview":"overview_overview__AR3FL","typing":"overview_typing__PuBiA","blink":"overview_blink__WZ7Cm"};